import BBookIcon from './BBookIcon'

// Replaces the generic "no data" cross: says what the list is for and what to do to fill it.
const BBookEmpty = ({ title, hint }) => (
  <div className='b_book_empty'>
    <BBookIcon name='info' size={22} />
    <p className='b_book_empty_title'>{title}</p>
    {hint ? <p className='b_book_empty_hint'>{hint}</p> : null}
  </div>
)

export default BBookEmpty

// A failed load says so where the content should be, with a way to try again instead of a blank page.
export const BBookLoadError = ({ message, retryLabel, onRetry }) => (
  <div className='b_book_empty b_book_empty_error' role='alert'>
    <BBookIcon name='warning' size={22} />
    <p className='b_book_empty_title'>{message}</p>
    <button className='b_book_secondary_button b_book_retry' onClick={onRetry}><BBookIcon name='refresh' size={16} />{retryLabel}</button>
  </div>
)
